// istanbul ignore next
export { default } from './container'



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-ownership/index.js